angular.module('picmonicng').component('achievementsComponent', {
  templateUrl: '/templates/app/pages/achievements/achievements.html',
  bindings: {},
  controller: [
    'UserService',
    'User',
    function (UserService, User) {
      var ctrl = this;
      ctrl.UserService = UserService;
      ctrl.achievements = User.queryv3({ resource: 'achievements' });
    },
  ],
});
